export default __webpack_public_path__ + "static/media/consensys-labs-icon-logo-white.0945a84b.png";